import { Fragment } from 'react'

import { StyledGrid } from '@web/components/common/LotGrid/LotGrid.styles'
import { LotCardLoader } from '@web/components/common/LotGridLoader/LotCardLoader'
import { LotMobileCardLoader } from '@web/components/common/LotGridLoader/LotMobileCardLoader'

import { DesktopContainer, MobileContainer } from './LotGridLoader.styles'

export const LotGridLoader = ({ numberOfLoaders = 8 }: LotGridLoaderProps) => {
  return (
    <StyledGrid>
      {[...Array(numberOfLoaders)].map((_, index) => {
        return (
          <Fragment key={`loader-${index}`}>
            <DesktopContainer>
              <LotCardLoader />
            </DesktopContainer>
            <MobileContainer>
              <LotMobileCardLoader />
            </MobileContainer>
          </Fragment>
        )
      })}
    </StyledGrid>
  )
}

interface LotGridLoaderProps {
  numberOfLoaders?: number
}
